import { useEffect } from "react";
import ReactDOM from "react-dom";

export const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Prevent background scroll
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  if (!isOpen) return null; // Don't render when closed

  return ReactDOM.createPortal(
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {children}
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>,
    document.getElementById("modal-root") // Ensure this div exists in `index.html`
  );
};

export default Modal;
